import { useSyncExternalStore } from 'react'

import { authStore } from '@/features/auth/services/auth-store'
import { authApi } from '@/features/auth/api/auth.api'
import { broadcastAuth } from '@/features/auth/services/auth-broadcast'

function subscribe(listener: () => void) {
  return authStore.subscribe(listener)
}

function getSnapshot() {
  return authStore.isAuthenticated()
}

export function useSession() {
  const isLoggedIn = useSyncExternalStore(subscribe, getSnapshot, getSnapshot)

  const logout = async () => {
    try {
      await authApi.logout()
    } catch {
      /* intentionally ignored */
    } finally {
      authStore.clear()
      authStore.clearSessionMarkers()
      broadcastAuth({ type: 'logout' })
    }
  }

  return { isLoggedIn, logout }
}
